import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { Button, Card, ContentWrapper, Spacer } from '~/components/elements'
import { ArrowBackIosOutlineIcon } from '~/components/icons'
import Loading from '~/components/loading'
import { Diagnostics } from '~/components/service/Diagnostics'
import { useRootStore } from '~/store/RootStore'

export const Route = createFileRoute('/_authenticated/service/service-tests')({
  pendingComponent: () => <Loading />,
  component: ServiceTestPage,
})

function ServiceTestPage() {
  const navigate = useNavigate({ from: '/home' })
  const { account } = useRootStore()
  const radius = account.getRadius

  return (
    <ContentWrapper>
      <Button
        size="small"
        variant="secondary"
        onClick={() => navigate({ to: '/home' })}
      >
        <ArrowBackIosOutlineIcon /> Back
      </Button>
      <Spacer height="24px" />

      <Card heading="Connection Status" padding="12px">
        {radius.timeOnline && radius.isConnected && (
          <Button className="inactive" variant="success">
            Online: {radius.timeOnline}
          </Button>
        )}
        {!radius.timeOnline && !radius.isConnected && (
          <Button className="inactive" variant="danger">
            Offline
          </Button>
        )}
      </Card>

      <Diagnostics />
    </ContentWrapper>
  )
}
